import { ofType } from 'redux-observable';
import { exhaustMap } from 'rxjs/operators';

import {
    createExternalCard,
    createExternalCardErrors,
    fetchExternalCards,
} from '@perpay-web/fintech/actions/entities/externalCards';
import {
    PAYMENT_PORTAL_CREATE_EXTERNAL_CARD,
    STORE_CREATE_EXTERNAL_CARD_SUCCESS,
} from '@perpay-web/fintech/constants/actionTypes';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const paymentPortalCreateExternalCard = (action$, state$) =>
    action$.pipe(
        ofType(PAYMENT_PORTAL_CREATE_EXTERNAL_CARD),
        exhaustMap((action) =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: () => [
                    createExternalCard(
                        action.payload.cardNumber,
                        action.payload.expiryDate,
                        action.payload.cvc,
                    ),
                ],
                waitFor: [STORE_CREATE_EXTERNAL_CARD_SUCCESS],
                waitForDispatch: () => [fetchExternalCards()],
                // The UI consumes the errors that are stored by the createExternalCard epic.
                errors: [createExternalCardErrors().type],
                errorDispatch: () => [],
                // Timeouts are handled within the card entity epic
            }),
        ),
    );
